import { render, staticRenderFns } from "./BodyRequestReset.vue?vue&type=template&id=cde9bbb0&scoped=true&"
import script from "./BodyRequestReset.vue?vue&type=script&lang=js&"
export * from "./BodyRequestReset.vue?vue&type=script&lang=js&"
import style0 from "./BodyRequestReset.vue?vue&type=style&index=0&id=cde9bbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde9bbb0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
